<template>
    <div class="app">
        <DefaultHeader @change-password="$bvModal.show('modal-change-password')" @logout="logout" :fullName="fullName" :roleName="roleName" />
        <div class="app-body">
            <AppSidebar fixed>
                <SidebarHeader/>
                <div class="sidebar-header-c">
                    <div class="show-on-mobile" style="margin: 1em">
                        <div style="line-height: 1.2">{{ fullName }}</div>
                        <div class="small font-weight-bold">{{ roleName }}</div>
                    </div>
                </div>
                <SidebarForm/>
                <SidebarNav :navItems="nav"></SidebarNav>
            </AppSidebar>
            <main class="main">
                <CustomBreadcrumb :list="list"/>
                <div class="container-fluid">
                <router-view></router-view>
                </div>
            </main>
        </div>
        <DefaultFooter/>
        <b-modal id="modal-change-password" title="Ubah Password"
            centered no-close-on-backdrop no-close-on-esc hide-footer
            @shown="$refs.input.focus()" @hidden="onHideChangePasswordModal"
        >
            <b-form-group label="Password Lama" class="password-form-group" style="max-width: none">
                <b-form-input ref="input" :type="input.opType" v-model="input.oldPassword" />
                <i :class="input.opType == 'password' ? 'fa fa-eye-slash' : 'fa fa-eye'" @click="changePasswordType('opType')" />
            </b-form-group>
            <b-form-group label="Password Baru" class="password-form-group" style="max-width: none">
                <b-form-input :type="input.npType" v-model="input.newPassword" />
                <i :class="input.npType == 'password' ? 'fa fa-eye-slash' : 'fa fa-eye'" @click="changePasswordType('npType')" />
            </b-form-group>
            <b-form-group label="Ulangi Password Baru" class="password-form-group" style="max-width: none">
                <b-form-input :type="input.cpType" v-model="input.confirmNewPassword" />
                <i :class="input.cpType == 'password' ? 'fa fa-eye-slash' : 'fa fa-eye'" @click="changePasswordType('cpType')" />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeChangePassword">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
import nav from '@/nav'
import { Sidebar as AppSidebar, SidebarForm, SidebarHeader, SidebarNav } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import DefaultHeader from './DefaultHeader'
import DefaultFooter from './DefaultFooter'
import CustomBreadcrumb from './CustomBreadcrumb'

export default {
    name: 'DefaultContainer',
    components: {
        AppSidebar,
        CustomBreadcrumb,
        DefaultHeaderDropdownAccnt,
        SidebarForm,
        SidebarHeader,
        SidebarNav,
        DefaultFooter,
        DefaultHeader
    },
    data () {
        return {

            nav: [],

            fullName: "",
            roleName: "",

            isSubmitting: false,

            input: {
                oldPassword: "",
                newPassword: "",
                confirmNewPassword: "",
                opType: "password",
                npType: "password",
                cpType: "password"
            },

        }
    },
    computed: {

        name () {
            return this.$route.name
        },

        list () {
            return this.$route.matched.filter((route) => (route.name || route.meta.label) && !route.meta.hideInBreadcrumb)
        }

    },
    methods: {

        executeChangePassword() {

            if(this.$helper.isBlank(this.input.oldPassword)) {
                return this.$helper.toastError(this, "Password lama tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.newPassword)) {
                return this.$helper.toastError(this, "Password baru tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.confirmNewPassword)) {
                return this.$helper.toastError(this, "Ulangi password baru tidak boleh kosong!")
            }

            if(this.input.newPassword != this.input.confirmNewPassword) {
                return this.$helper.toastError(this, "Password baru dan ulangi password baru tidak sama!")
            }

            let payload = {
                current: this.input.oldPassword,
                new: this.input.newPassword,
                repeat: this.input.confirmNewPassword
            }

            this.isSubmitting = true
            this.$axios.post("user/change-password", payload).then(res => {

                this.$bvModal.hide("modal-change-password")
                this.$helper.toastSuccess(this, "Password berhasil diubah!")
                this.onHideChangePasswordModal()

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        changePasswordType(section) {

            if(this.input[section] == "password") {
                this.input[section] = "text"
            }
            else {
                this.input[section] = "password"
            }

        },

        onHideChangePasswordModal() {

            this.input.oldPassword = ""
            this.input.newPassword = ""
            this.input.confirmNewPassword = ""
            this.input.opType = "password"
            this.input.npType = "password"
            this.input.cpType = "password"

        },

        logout() {

            var version = localStorage.getItem("version")
            localStorage.clear()
            sessionStorage.clear()
            localStorage.setItem("", version)

            this.$router.push("/login")

        }

    },
    created() {

        // Auto-redirect to login page if token does not exist --> moved to router
        if(localStorage.getItem("token") == null) {
            this.$router.push({ path: "/login" })
            return
        }

        this.$axios.get("user/check-token")

        this.fullName = localStorage.getItem("fullname")
        this.roleName = localStorage.getItem("roleName")

        // Consolidate navigation properties
        let navs = JSON.parse(JSON.stringify(nav.items))
        let permissions = localStorage.getItem("permissions").split(",").map(it => Number(it))
        // console.log(permissions)

        if(localStorage.getItem("roleId") != 1) { // Bukan superadmin, permission-based

            let newNav = []
            navs.forEach(item => {

                if(!item.hasOwnProperty("children") && (item.permission == null || permissions.includes(item.permission))) {
                    newNav.push(item)
                }

                if(item.hasOwnProperty("children")) {

                    newNav.push(item)

                    let children = [];
                    item.children.forEach(it => {
                        if(it.permission == null || permissions.includes(it.permission)) {
                            children.push(it)
                        }
                    })

                    item.children = children

                    if(children.length == 0) {
                        newNav.pop();
                    }

                }

            })

            this.nav = newNav

        }
        else {
            this.nav = navs
        }

    },
    mounted() {

        // Check versioning. Hard refresh if reload is required
        let reloadStatus = localStorage.getItem("reload")

        if(reloadStatus != null && reloadStatus == 1) {
            localStorage.removeItem("reload")
            window.location.reload()
        }

    }
}
</script>
